import moment from 'moment';

export const dateMixin = {
    methods: {
        today(): string {
            return moment().format('MM/DD/YYYY');
        },
    },
};

export const dateFormatMixin = {
    methods: {
        formatDate(dateStr): string {
            return moment(dateStr).format('MM/DD/YYYY');
        },
    },
};

export const datetimeFormatMixin = {
    methods: {
        formatDatetime(dateTimeStr, showFullYear = false): string {
            if (showFullYear) {
                return moment(dateTimeStr).format('MM/DD/YYYY @ h:mm a');
            }
            return moment(dateTimeStr).format('MM/DD/YY @ h:mm a');
        },
        // Appointments are stored as a datetime even when only the day is
        // known, so hasTime decides whether the time of day means anything.
        formatAppointmentDatetime(dateTimeStr, hasTime = true, showFullYear = false): string {
            if (!dateTimeStr) {
                return '';
            }
            const yearFormat = showFullYear ? 'MM/DD/YYYY' : 'MM/DD/YY';
            if (!hasTime) {
                return moment(dateTimeStr).format(yearFormat);
            }
            return moment(dateTimeStr).format(`${yearFormat} @ h:mm a`);
        },
    },
};
